import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { createStartup } from '../api/startups.api';
import { ROUTES } from '@/lib/constants/routes';
import { clearStartupInviteLanding } from '@/lib/auth/startup-invite-landing';

/**
 * Create-startup mutation (MYN-46 Step 4). On success routes to the confirmation
 * screen carrying the new entity id + name; the session role switch to Startup
 * Admin is performed there (see StartupCreatedPage / useRefreshSession).
 */
export function useCreateStartup() {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: createStartup,
    onSuccess: (startup) => {
      // The invite this tab accepted is now redeemed (MYN-311).
      clearStartupInviteLanding();
      navigate(ROUTES.STARTUP_CREATED, {
        state: { entityId: startup.entityId, companyName: startup.companyName },
      });
    },
  });
}
